module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_8_m.cfa589563d2b90d2fa54d99702a2360b.png";